module.exports = __webpack_public_path__ + "static/media/static-value-icon.528876ba.svg";